import { render, staticRenderFns } from "./FormArchivos.vue?vue&type=template&id=1db4d6f6&"
import script from "./FormArchivos.vue?vue&type=script&lang=js&"
export * from "./FormArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports